 import service from '../Common'
 import constants from '../../../settings/shared/constants'
 
 function getAllPlatformProvisioner() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.platformprovisioner.getAllplatformProvisioner,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function PostPlatformProvisioner(ProvisionerData) {
     let jwtToken = localStorage.getItem('accessToken');
     let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
         return service({
             url: constants.api.platformprovisioner.postplatformProvisioner,
             method: 'POST',
             headers: headers,
             data:  ProvisionerData
         }); 
  }

  function UpdatePlatformProvisioner(updateData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.platformprovisioner.updateplatformProvisioner,
            method: 'PUT',
            headers: headers,
            data:  updateData
        }); 
 }

 function deletePlatformProvisioner() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.platformprovisioner.removeplatformProvisioner,
            method: 'DELETE',
            headers: headers,
            data:  ''
        }); 
 }
  
 //To export authentication function
 const PlatformProvisionerService = {
    getAllPlatformProvisioner, PostPlatformProvisioner,UpdatePlatformProvisioner,deletePlatformProvisioner
 }
 
 export default PlatformProvisionerService;
 